import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Chart } from 'chart.js';
import { ChartJsConfig } from './chart.model';

@Component({
  selector: 'miq-chart-render',
  templateUrl: './chart-render.component.html',
  styleUrls: ['./chart-render.component.scss'],
  standalone: false,
})
export class ChartRenderComponent implements OnInit, OnChanges, OnDestroy {
  @Input() public chartData: ChartJsConfig;
  @ViewChild('canvas', { static: true }) canvas: ElementRef;

  private chart: any;

  ngOnInit() {
    this.chart = new Chart(this.canvas.nativeElement.getContext('2d'), this.chartData);
  }

  ngOnChanges(change: SimpleChanges) {
    if (change.chartData && !change.chartData.firstChange) {
      this.chart.update();
    }
  }

  ngOnDestroy() {
    this.canvas = null;
  }
}
